module.exports = __webpack_public_path__ + "static/media/bird.936bc40f.jpg";